module.exports = __webpack_public_path__ + "static/koen_comp-91b546dbfd48d8294b881c95a6745313.jpg";